import React from "react";

import Head from "next/head";

import CreditsComponent from "../../components/CreditsComponent/CreditsComponent";
import FooterNavComponent from "../../components/FooterComponent/FooterNavComponent/FooterNavComponent";
import GetInTouchComponent from "../../components/FooterComponent/GetInTouchComponent/GetInTouchComponent";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import TrustedByComponent from "../../components/HomeComponent/TrustedByComponent/TrustedByComponent";
import { NextHead } from "../../components/NextHead/NextHead";

const CreditsPage = () => {
  return (
    <React.Fragment>
      <NextHead title={"Credits"} description={""} keywords={""} image={""} />
      <Head>
        <link rel="canonical" href={`${process.env.BASE_URL}/credits`} />
      </Head>
      <HeaderComponent />
      <CreditsComponent />
      <div className="about_us_trutedby_container">
        <TrustedByComponent />
      </div>
      <GetInTouchComponent />
      <FooterNavComponent />
    </React.Fragment>
  );
};

export default CreditsPage;
